<template>
  <div @click.stop>
    <div class="mt-30">
      <div class="d-flex flex-row justify-content-between">
        <h5 class="clr-3F3F3F fs-12">Fade in</h5>
        <input
          v-model="fadeIn"
          :max="getMaxValueForFade"
          class="effects-input"
          type="text"
          min="0"
          step="0.1"
          @keydown.enter="verifyFadeInValue"
        >
      </div>
      <input
        id="range-slider__range6"
        v-model="fadeIn"
        :max="getMaxValueForFade"
        type="range"
        class="range__input"
        min="0"
        step="0.1"
        @click.stop
        @input="updateAudioDetails"
      >
    </div>
    <div class="mt-30">
      <div class="d-flex flex-row justify-content-between">
        <h5 class="clr-3F3F3F fs-12">Fade out</h5>
        <input
          v-model="fadeOut"
          :max="getMaxValueForFade"
          class="effects-input"
          type="text"
          min="0"
          step="0.1"
          @keydown.enter="verifyFadeOutValue"
        >
      </div>
      <input
        id="range-slider__range7"
        v-model="fadeOut"
        :max="getMaxValueForFade"
        type="range"
        class="range__input"
        min="0"
        step="0.1"
        @click.stop
        @input="updateAudioDetails"
      >
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';

export default {
  name:  'AudioOptions',
  props: {
    product: Object,
  },
  data() {
    return {
      trimDuration: this.product && this.product.audioDetails ? this.makeDecimalPartEven(this.product.audioDetails.trimDuration) : 0,
      fadeIn:       this.product && this.product.audioDetails ? parseFloat(this.product.audioDetails.fadeIn).toFixed(1) : 0,
      fadeOut:      this.product && this.product.audioDetails ? (this.product.audioDetails.endTime - this.product.audioDetails.fadeOut).toFixed(1) : 0,
    };
  },
  computed: {
    getMaxValueForFade() {
      if (this.product && this.product.audioDetails) {
        if (this.trimDuration >= 10) {
          return 5;
        }
        return (this.trimDuration / 2).toFixed(1);
      }
    },
  },
  mounted() {
    EventBus.$on('UpdateFadeInAndFadeOutMaxValue', this.UpdateFadeInAndFadeOutMaxValue);
    EventBus.$on('UpdateFadeInFadeOutValue', this.UpdateFadeInFadeOutValue);
  },
  methods: {
    makeDecimalPartEven(floatNumber) {
      const integerPart = Math.floor(floatNumber);
      const decimalPart = floatNumber - integerPart;
      if ((decimalPart * 10) % 2 !== 0) {
        return integerPart + decimalPart - 0.1;
      }
      return floatNumber;
    },
    UpdateFadeInFadeOutValue(fadeIn, fadeOut) {
      this.fadeIn  = parseFloat(fadeIn).toFixed(1);
      this.fadeOut = parseFloat(fadeOut).toFixed(1);
    },
    UpdateFadeInAndFadeOutMaxValue(trimDuration) {
      if (trimDuration >= 0.1) {
        this.trimDuration = this.makeDecimalPartEven(trimDuration);
        this.verifyFadeInValue();
        this.verifyFadeOutValue();
        this.updateAudioDetails();
      } else {
        this.fadeIn  = 0;
        this.fadeOut = 0;
      }
    },
    updateAudioDetails() {
      EventBus.$emit('updateFadeInAndFadeOutValues', this.fadeIn, this.fadeOut);
    },
    verifyFadeInValue() {
      if (this.trimDuration > 10) {
        if (this.fadeIn > 5.1) {
          this.fadeIn = 5;
        } else if (this.fadeIn <= 0) {
          this.fadeIn = 0;
        }
      } else if (this.fadeIn > this.trimDuration / 2) {
        this.fadeIn = (this.trimDuration / 2).toFixed(1);
      } else if (this.fadeIn <= 0) {
        this.fadeIn = 0;
      }
      this.updateAudioDetails();
    },
    verifyFadeOutValue() {
      if (this.trimDuration > 10) {
        if (this.fadeOut > 5.1) {
          this.fadeOut = 5;
        } else if (this.fadeOut <= 0) {
          this.fadeOut = 0;
        }
      } else if (this.fadeOut > this.trimDuration / 2) {
        this.fadeOut = (this.trimDuration / 2).toFixed(1);
      } else if (this.fadeOut <= 0) {
        this.fadeOut = 0;
      }
      this.updateAudioDetails();
    },
  },
};
</script>

<style scoped lang="scss">
.effects-input{
  text-align: center;
  width: 20px;
  border: 1px solid #00a6f5;
  border-radius: 4px;
  -webkit-appearance: none;
  appearance: none;
  box-sizing: border-box;
  min-width: 8px;
  outline: none;
  padding: 0 0 1px;
}
.range__input {
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 5px;
  background: #d6d6d6;
  outline: none;
  padding: 0;
  margin: 0;
}

.range__input::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: #ffffff;
  border: 2px solid #3bb0fa;
  cursor: pointer;
  transition: background 0.15s ease-in-out;
}

/*On hover change colour of black thumb into green 🟢 and scale size*/
.range__input::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  background: #3bb0fa;
}

.range__input:active::-webkit-slider-thumb {
  transform: scale(1.1);
  background: #3bb0fa;
}
</style>
